import { type BaseProductElementProps } from "~/domains/product/types/BaseProductElementProps";
import { useProductContext } from "~/domains/product/ProductContext";
import { Translation } from "~/app/i18n/Translation";
import { Link, type LinkProps, LinkType } from "~/common/components/Link";
import { useProductDetailsUrl } from "~/features/PackageRestriction/hooks/useProductDetailsUrl";
import type { ReactNode } from "react";
import { styled, Box } from "~/common/mui";

interface Props extends BaseProductElementProps {
  as?: keyof JSX.IntrinsicElements;
  clickable?: boolean;
  linkProps?: LinkProps;
  truncate?: boolean;
}

const Root = styled(Box, {
  shouldForwardProp: (prop) => prop !== "truncate",
})<{ truncate?: boolean }>(({ truncate }) => ({
  ...(truncate && {
    "& a": {
      display: "inline",
    },
  }),
}));

export const ShortDescription = (props: Props) => {
  const { clickable = true, linkProps, truncate, as } = props;
  const product = useProductContext(props);
  const Component = as ?? "div";

  let href: string | undefined = useProductDetailsUrl(product);
  if (linkProps?.href) {
    href = linkProps.href;
  }

  let content: ReactNode = <Translation {...product.shortDescription} />;

  if (clickable && href) {
    content = (
      <Link href={href} variant={LinkType.SECONDARY} {...linkProps}>
        {content}
      </Link>
    );
  }

  return (
    <Root as={Component} className={props.className} truncate={truncate}>
      {content}
    </Root>
  );
};
